import { fetch } from "../lib/network";
import decamelizeKeys from "decamelize-keys";
import AppSettings from "../config";
import PermitsService from "../services/PermitsService";
import { buildQuery } from "../lib/network";

export type PermitFormData = Awaited<ReturnType<typeof PermitsService.formsDetail>>["data"];
export type PermitFormDataInclude = PermitFormData["included"][number];
export type PermitFormField = Extract<PermitFormDataInclude, { type: "permits-form-field" }>;
export type PermitFormSection = Extract<PermitFormDataInclude, { type: "permits-form-section" }>;
export function getPermitForm(networkHeaders: any) {
  return (id: string) => {
    return buildQuery(PermitsService.formsDetail(id, { headers: networkHeaders }), (res) => {
      return res.data;
    });
  };
}

export const getPermitsForms = (networkHeaders: any) => () =>
  fetch(`${AppSettings.PERMITS_FORMS_API_URL}`, {
    method: "GET",
    headers: networkHeaders,
  }).then((res) => res.json());

export const putPermitsForm = (networkHeaders: any, id: string) => (body: any) =>
  fetch(`${AppSettings.PERMITS_FORMS_API_URL}/${id}`, {
    method: "PUT",
    headers: networkHeaders,
    body: JSON.stringify({ data: { attributes: decamelizeKeys(body, "-") } }),
  });

export const postPermitsForm = (networkHeaders: any) => (body: any) =>
  fetch(`${AppSettings.PERMITS_FORMS_API_URL}`, {
    method: "POST",
    headers: networkHeaders,
    body: JSON.stringify({ data: { attributes: decamelizeKeys(body, "-") } }),
  });
